var _ = require('underscore');

function proxyEvents(from, eventNames) {
  _.each(eventNames, function(eventName) {
    this.listenTo(from, eventName, function() {
      var args = _.toArray(arguments);
      args.unshift(eventName);
      this.trigger.apply(this, args);
    });
  }, this);
}

module.exports = proxyEvents;



//////////////////
// WEBPACK FOOTER
// ./node_modules/backbone.obscura/src/proxy-events.js
// module id = 881
// module chunks = 1